import React, { Component } from 'react';
import { Tag } from 'antd';
import styles from './style.less';

export default class Header extends Component {
  render() {
    const {
      title,
      desc,
      organizer,
      status,
      teamNum,
      startTime,
      endTime,
      min,
      max,
    } = this.props;

    const statusText =
      status == 0 ? '未开始' : status == 1 ? '进行中' : '已结束';
    const statusColor = status == 0 ? 'default' : status == 1 ? 'green' : 'red';

    return (
      <div className={styles['container']}>
        <div className={styles['left']}>
          <div className={styles['title']}>{title}</div>
          {desc ? <div className={styles['desc']}>{desc}</div> : null}
          {organizer ? (
            <div className={styles['organizer']}>举办方：{organizer}</div>
          ) : null}
        </div>
        <div className={styles['right']}>
          <div className={styles['stat']}>
            <div className={styles['stat-value']}>{teamNum}</div>
            <div className={styles['stat-label']}>参赛队伍</div>
          </div>
          <div className={styles['stat']}>
            <div className={styles['stat-value']}>
              {min === max ? `${min}人` : `${min}-${max}人`}
            </div>
            <div className={styles['stat-label']}>人数限制</div>
          </div>
          <div className={styles['stat']}>
            <Tag color={statusColor} className={styles['status-tag']}>
              {statusText}
            </Tag>
            <div className={styles['stat-label']}>状态</div>
          </div>
          <div className={styles['time']}>
            {startTime ? (
              <React.Fragment>
                <div className={styles['time-value']}>{startTime}</div>
                <div className={styles['time-label']}>开始时间</div>
              </React.Fragment>
            ) : null}
            <div className={styles['time-value']}>{endTime}</div>
            <div className={styles['time-label']}>报名截止</div>
          </div>
        </div>
      </div>
    );
  }
}